import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Send, KeyRound, Hash, Save, PlugZap, Loader2, CheckCircle2 } from "lucide-react";

const inp = "w-full bg-white/5 border border-white/10 rounded-xl px-3.5 py-2.5 text-sm focus:outline-none focus:border-[#229ED9]/60";

export function TelegramSettings() {
  const [cfg, setCfg] = useState({ channel: "", has_token: false, token_hint: "" });
  const [token, setToken] = useState("");
  const [channel, setChannel] = useState("");
  const [busy, setBusy] = useState("");

  useEffect(() => { api.get("/telegram/config").then((r) => { setCfg(r.data); setChannel(r.data.channel); }).catch(() => {}); }, []);

  const save = async () => {
    if (!token.trim() && !cfg.has_token) { toast.error("Inserisci il token del bot"); return; }
    if (!channel.trim()) { toast.error("Inserisci il canale (es. @mio_canale)"); return; }
    setBusy("save");
    try {
      const r = await api.put("/telegram/config", { bot_token: token, channel });
      setCfg(r.data); setToken("");
      toast.success("Configurazione Telegram salvata");
    } catch { toast.error("Salvataggio non riuscito"); }
    finally { setBusy(""); }
  };
  const test = async () => {
    setBusy("test");
    try {
      const r = await api.post("/telegram/test");
      toast.success(`Connesso: @${r.data.bot} → ${r.data.chat_title}`);
    } catch (e) { toast.error(e.response?.data?.detail || "Verifica non riuscita"); }
    finally { setBusy(""); }
  };

  return (
    <div className="glass rounded-2xl p-5 space-y-4 border-l-4" style={{ borderColor: "#229ED9" }} data-testid="telegram-settings">
      <div>
        <div className="flex items-center gap-2 mb-1">
          <Send className="h-5 w-5 text-[#229ED9]" />
          <h3 className="font-display font-bold">Pubblicazione su Telegram</h3>
          {cfg.has_token && cfg.channel && <span className="ml-auto flex items-center gap-1 text-[11px] text-emerald-300" data-testid="telegram-configured-badge"><CheckCircle2 className="h-3.5 w-3.5" /> Configurato</span>}
        </div>
        <p className="text-xs text-slate-400">
          Crea un bot con <span className="text-[#5cc0f0]">@BotFather</span> (comando /newbot), copia il token e aggiungi il bot come
          <strong className="text-slate-200"> amministratore</strong> del tuo canale. Poi inserisci qui token e @nome del canale.
        </p>
      </div>
      <div>
        <label className="text-xs text-slate-400 flex items-center gap-1.5 mb-1.5"><KeyRound className="h-3.5 w-3.5" /> Token del bot</label>
        <input data-testid="telegram-token-input" type="password" value={token} onChange={(e) => setToken(e.target.value)} className={inp}
          placeholder={cfg.has_token ? `Token salvato (${cfg.token_hint}) · lascia vuoto per mantenerlo` : "123456789:AAH…"} autoComplete="off" />
      </div>
      <div>
        <label className="text-xs text-slate-400 flex items-center gap-1.5 mb-1.5"><Hash className="h-3.5 w-3.5" /> Canale</label>
        <input data-testid="telegram-channel-input" value={channel} onChange={(e) => setChannel(e.target.value)} className={inp}
          placeholder="@mio_canale oppure -1001234567890" />
      </div>
      <div className="flex gap-2">
        <button data-testid="telegram-save-button" onClick={save} disabled={!!busy}
          className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-[#229ED9] text-white text-sm font-semibold hover:opacity-90 transition-opacity disabled:opacity-60">
          {busy === "save" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Salva
        </button>
        <button data-testid="telegram-test-button" onClick={test} disabled={!!busy || !cfg.has_token}
          className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-white/5 hover:bg-white/10 text-sm transition-colors disabled:opacity-50">
          {busy === "test" ? <Loader2 className="h-4 w-4 animate-spin" /> : <PlugZap className="h-4 w-4" />} Verifica connessione
        </button>
      </div>
    </div>
  );
}
